import { createGlobalStyle } from 'styled-components';
import { styledComponentProps } from '../types/theme';

export const GlobalStyles = createGlobalStyle`
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: ${({ theme }: styledComponentProps): string =>
			theme.text.fontFamily};
    p {
        margin:0;
    }
}

  html {
    scroll-behavior: smooth;
  }

  .MuiGrid-item {
      margin: 0 !important;
  }

  .media-wrapp drupal-media:empty{
    display: block;
    width: 100%;
    aspect-ratio: 16 / 9;
    background-color: rgba(0,0,0,0.1);
  }

  [dir="ltr"] > .media-wrapp * {
    text-align: left;
  }

  [dir="rtl"] > .media-wrapp * {
    text-align: right;
  }

  .media-wrapp [dir="ltr"] {
    text-align: left!important;
  }

  .media-wrapp [dir="rtl"] {
    text-align: right!important;
  }
`;
